import browserDetector from 'bowser';

const browserInfo = {
  chrome: false,
  detectedVersion: undefined,
  edge: false,
  firefox: false,
  IE: false,
  opera: false,
  safari: false,
  undefined: false
};

const { chrome, chromium, msedge, firefox, msie,
    opera, safari, mobile, tablet, windows } = browserDetector;

browserInfo.chrome = Boolean(chrome || chromium);
browserInfo.edge = Boolean(msedge);
browserInfo.firefox = Boolean(firefox);
browserInfo.IE = Boolean(msie);
browserInfo.opera = Boolean(opera);
browserInfo.safari = Boolean(safari);
browserInfo.chromium = Boolean(chromium);
browserInfo.undefined = !(chrome || msedge || firefox || msie || opera || safari);
browserInfo.detectedVersion = browserInfo.undefined
    ? undefined
    : (parseFloat(browserDetector.version) || undefined);

// IE11 in windows 10 will flag the browser as a tablet browser for some reason
browserInfo.isMobile = (mobile || tablet) && !(msie && windows);

export default browserInfo;

export const helpUrl = (language = 'en') => (`https://www.lifesize.com/${language}/share-help`);
export const getQueryParams = str => (
    (str || document.location.search).replace(/(^\?)/,'').split("&").map(function(n){return n = n.split("="),this[n[0]] = n[1],this}.bind({}))[0]  //eslint-disable-line
);



// WEBPACK FOOTER //
// ./src/utils/browserUtils.js